module.exports = __webpack_public_path__ + "img/dg10.38704689.jpg";